<script>
	import '../../app.css';
	import { onMount } from 'svelte';

	let windowX;
	let windowY;
	export let data;
	const fetchedValues = data.fetchedValues;
	let backgroundImage;
	let navHeight;

	$: {
		backgroundImage = fetchedValues.backgroundImg;
		if (typeof window !== 'undefined') {
			document.documentElement.style.setProperty('--background-image', `url(${backgroundImage})`);
		}
	}

	function getNavHeight() {
		navHeight = document.getElementsByTagName('nav')[0]?.offsetHeight || 0;
	}

	onMount(() => {
		getNavHeight();
	});
</script>

<svelte:head>
	<title>Impressum</title>
	<meta name="description" content="Homepage" />
</svelte:head>

<svelte:window on:resize={getNavHeight} bind:innerHeight={windowY} bind:innerWidth={windowX} />

<section class="relative" style="font-family: 'Titillium Web', sans-serif; max-width 800px;">
	<div class="background-image" />
	<div
		style="margin-top: {navHeight + 50}px;"
		class={windowX < 500 ? 'containerBoxSmall' : 'containerBox '}
	>
		<div class="content">
			{#each fetchedValues.impressum as item}
				<h2>{item.Titel ? item.Titel : ''}</h2>
				<p>{item.Text ? item.Text : ''}</p>
				{#if item.SubTitleUndText != null}
					{#each item.SubTitleUndText as subItem}
						<h3>{subItem.SubTitle ? subItem.SubTitle : ''}</h3>
						<p class="subText">{subItem.Text ? subItem.Text : ''}</p>
					{/each}
				{/if}
			{/each}
		</div>
	</div>
</section>

<style>
	/* CSS styles for the Impressum page */
	:root {
		--primary-color: #aa9173;
	}
	p {
		line-height: 2rem;
		font-size: 1.1rem;
		font-weight: 300;
		margin: 0.5rem 0;
	}
	h1,
	h2 {
		color: #333;
		font-weight: 600;
	}

	h2 {
		font-size: 1.5rem;
		margin: 1rem 0;
	}

	h3 {
		font-size: 1.2rem;
		font-weight: 600;
		margin: 1rem 0 1rem 1rem;
	}
	.subText {
		margin: 1rem 0 1rem 1rem;
	}

	a {
		color: var(--primary-color);
		text-decoration: none;
	}

	a:hover {
		text-decoration: underline;
	}
	.font-heading {
		font-weight: 600;
	}
	.subheader {
		font-weight: 600;
		font-size: 1.2rem;
		margin: 1rem 0;
	}
	.background-image {
		background: var(--background-image) no-repeat center center;
		background-size: cover;
		position: fixed;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		opacity: 1;
		z-index: -1;
		filter: blur(3px) brightness(0.8) contrast(1);
	}
	.containerBox {
		padding: 3rem;
		background-color: #f9f9f9d8;
		border-radius: 8px;
		box-shadow: 0 0 10px var(--primary-color);
		width: 100%;
		margin-bottom: 5rem;
	}
	.containerBoxSmall {
		padding: 2rem;
		background-color: #f9f9f9d8;
		border-radius: 0px;
		box-shadow: 0 0 10px var(--primary-color);
		width: 100%;
		max-width: 900px;
	}
	.containerBoxSmall {
		max-width: 95%;
	}
	.containerBox {
		max-width: 1200px;
	}
	section {
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
